<template>
  <div class="w-1/2">
    <div class="tab__content">
      <div class="tab__content__item tab__active">
        <h4 class="tab__content__title">{{ $lang.app.AGREEMENT }}</h4>
        <div v-if="application.agreement"
             class="mb-10">
          <Loader v-if="loading" class="my-5"/>
          <div v-else class="w-full docs__pdf">
            <iframe :src="agreementPdfFile"
                    allowfullscreen
                    height="100%"
                    width="100%"
            ></iframe>
          </div>

          <div v-for="additional in application.agreement.additionalAgreements"
               :key="additional.id" class="resolution__item resolution__opened mt-8">
            <div class="resolution__doc__header">
              <div class="resolution__doc__header__left">
                <span class="resolution__doc__title">{{ $lang.app.ADDITIONAL_AGREEMENT }}</span>
              </div>
              <div class="resolution__doc__header__right">
                <span class="resolution__doc__status green__light">{{ $lang.app[additionalAgreementStatusesGetLabelRefByValue(additional.status)] }}</span>
              </div>
            </div>
            <div class="resolution__body">
              <div class="resolution__card__files">
                <div class="file__grid">
                  <div class="cursor-pointer file__item" @click="openFile(additional.id, additional.lastFile?.file?.id)">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                    </svg>
                    <span class="file__item__name">
												{{ additional.lastFile?.file?.filename }}
                    </span>
                  </div>
                </div>
                <div v-if="additional.lastFile?.basisFile" class="file__grid">
                  <div class="cursor-pointer file__item" @click="openFile(additional.id, additional.lastFile?.basisFile?.id)">
                    <svg viewBox="0 0 24 24" width="24" height="24">
                      <use xlink:href="@/assets/v2/img/sprite.svg#icon__file__pdf"></use>
                    </svg>
                    <span class="file__item__name">
												{{ additional.lastFile?.basisFile?.filename }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="additional.status === additionalAgreementStatusesGetValueByKey('ON_CONFIRM')" class="flex justify-between py-4">
                <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_REWORK_ADDITIONAL_AGREEMENT_ACTION')"
                        type="button" class="button button--small red__lighter"
                        @click="$emitter.emit('openApplicationAdditionalAgreementReturnModal', additional)">
                  {{ application.actions.find(action => action.constName === 'APPLICATIONS_REWORK_ADDITIONAL_AGREEMENT_ACTION').name }}
                </button>
                <button v-if="application.actions.some(action => action.constName === 'APPLICATIONS_ACCEPT_ADDITIONAL_AGREEMENT_ACTION')"
                        type="button" class="button button--small green__lighter"
                        @click="$emitter.emit('openApplicationAdditionalAgreementAcceptModal', {application, additional})">
                  {{ application.actions.find(action => action.constName === 'APPLICATIONS_ACCEPT_ADDITIONAL_AGREEMENT_ACTION').name }}
                </button>

                <AcceptModal/>

                <ReturnModal/>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import applicationApi from "@/api/employee/application"
import {
  getValueByKey as additionalAgreementStatusesGetValueByKey,
  getLabelRefByValue as additionalAgreementStatusesGetLabelRefByValue
} from "@/helpers/constants/additionalAgreementStatuses";
import AcceptModal from "../../../components/employee/application/additional-agreement/modals/AcceptModal.vue";
import ReturnModal from "../../../components/employee/application/additional-agreement/modals/ReturnModal.vue";

export default {
  components: {
    AcceptModal,
    ReturnModal
  },
  props: {
    application: Object
  },
  data() {
    return {
      loading: false,
      agreementPdfFile: null,
    }
  },
  created() {
    this.getFile()
  },
  methods: {
    additionalAgreementStatusesGetValueByKey,
    additionalAgreementStatusesGetLabelRefByValue,
    getFile() {
      this.loading = true
      applicationApi
          .getApplicationAgreementFile(
              this.application.id,
              this.application.agreement.id,
              this.application.agreement.lastAgreementFile.file.id)
          .then(({ data }) => {
            this.agreementPdfFile = `data:application/pdf;base64,${data.base64}`;
          })
          .catch((error) => {
            this.$snotify.error(error);
          }).finally(() => {
        this.loading = false
      });
    },
    openFile(additionalId, fileId) {
      this.$emitter.emit('open-loader-modal')
      applicationApi.getApplicationAdditionalAgreementFile(
          this.application.id,
          this.application.agreement.id,
          additionalId,
          fileId
      )
          .then((response) => {
            this.$emitter.emit('open-file-modal', response.data)
          })
          .catch((error) => {
            this.$snotify.error(error);
          })
          .finally(() => {
            this.$emitter.emit('close-loader-modal')
          });
    },
  }
}
</script>